import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import ServiceFooter from '../Common/ServiceFooter';
import { useSessionHeartbeat } from '../../hooks/useSessionHeartbeat';

/**
 * 認証済みスタッフ画面のレイアウトガード。配下のルートを描画しつつ、
 * セッション検証ハートビート（削除済みユーザーの即時ログアウト）を実行する。feast-fe ADR 0014。
 */
const SessionGuard: React.FC = () => {
  useSessionHeartbeat();
  // 全認証画面へフッターを一括適用する（各ページでの個別配置はしない）。
  // コンテンツが短い画面でもフッターがビューポート最下部に張り付くよう flex で下寄せする。
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
      <ServiceFooter />
    </Box>
  );
};

export default SessionGuard;
